import React from 'react';
import PropTypes from 'prop-types';
import UserAvatarUploader from 'components/UserPrimaryData/UserAvatarUploader';
import Localize from 'components/Localize';
import { CloseButton } from 'shared';
import { ModalContent, ErrorText } from './UploadAvatarModalStyled';

const UploadAvatarModal = ({
  user, onUpload, onClose, error,
}) => (
  <ModalContent>
    <CloseButton onClick={onClose} top="24px" right="20px" zIndex={1} />
    <Localize id="click-image-update-avatar" />
    <div className="avatar">
      <UserAvatarUploader
        avatar={user.avatar}
        userFirstName={user.first_name}
        userLastName={user.last_name}
        isEditable
        onAvatarUpload={onUpload}
      />
    </div>
    {error && (
      <ErrorText>
        <Localize id="issue-image-uploading-please-try-again" />
      </ErrorText>
    )}
  </ModalContent>
);

UploadAvatarModal.propTypes = {
  onUpload: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  error: PropTypes.bool.isRequired,
  // `role` intentionally omitted: this modal only uses avatar/first_name/last_name
  // and is fed Header's role-less `user`. Declaring role `isRequired` produced a
  // spurious dev-only PropTypes warning (same root cause as the Header fix).
  user: PropTypes.shape({
    pk: PropTypes.string,
    first_name: PropTypes.string,
    email: PropTypes.string,
    birthday: PropTypes.string,
    phone: PropTypes.string,
    location: PropTypes.string,
    last_name: PropTypes.string,
    avatar: PropTypes.string,
  }),
};

UploadAvatarModal.defaultProps = {
  user: null,
};

export default UploadAvatarModal;
